<script>
import { retailConnectTranslation } from 'components/retail-connect/retail-connect-online-retailer/RetailConnectTranslation';
import GETONLINERETAILERSBYPRODUCTIDS from 'gql/getOnlineRetailersByProductIds.gql';

export default {
  data() {
    return {
      retailers: null,
      retailerFacets: null,
      retailerServiceType: null,
      facetsSelection: {
        BusinessTypes: {
          IsB2B: false,
          IsB2C: false,
        },
        DeliveryTypes: {
          IsExpress: false,
          IsPickup: false,
          IsNormal: false,
          IsDeliveryToConstruction: false,
        },
        PaymentTypes: {
          IsCash: false,
          IsCreditCard: false,
          IsDebitTransfer: false,
          IsEcCard: false,
          IsIdeal: false,
          IsInvoice: false,
          IsMobilePayment: false,
          IsPaymentInAdvance: false,
          IsPaypal: false,
        },
      },
    };
  },
  apollo: {
    getOnlineRetailersByProductIds: {
      query: GETONLINERETAILERSBYPRODUCTIDS,
      errorPolicy: 'all',
      variables() {
        return {
          baseSiteId: this.$fischer.baseSiteId(),
          language: this.$fischer.siteLanguage(),
          serviceType: this.serviceType,
          products: this.productIds,
          useGtins: this.$fischer.useGtins(),
        };
      },
      result(res) {
        this.retailers = res?.data?.getOnlineRetailersByProductIds || [];
        this.retailers = this.retailers.map((retailer) => ({
          ...retailer,
          BusinessTypes: {
            IsB2B: retailer.IsB2B,
            IsB2C: retailer.IsB2C,
          },
        }));

        this.setFacets();
      },
      skip() {
        return IS_SSR || !this.productIds || !(this.isRetailConnect || this.isRetailConnectCart);
      },
      error() {
        this.error = true;
      },
    },
  },
  computed: {
    isRetailConnect() {
      return this.$fischer.shop.isRetailConnect();
    },
    isRetailConnectCart() {
      return this.$fischer.shop.isRetailConnectCart();
    },
    serviceType() {
      if (this.retailerServiceType) {
        return this.retailerServiceType;
      }

      if (this.productIds && this.productIds.length > 1) {
        return 'cart';
      }

      return 'online';
    },
  },
  methods: {
    setFacets() {
      const facets = [];

      Object.keys(this.facetsSelection).forEach((facetType) => {
        const facet = {
          multiselect: true,
          name: retailConnectTranslation(facetType, this.$dict),
          elements: [],
        };

        Object.keys(this.facetsSelection[facetType]).forEach((facetName) => {
          let counter = 0;

          this.retailers.forEach((retailer) => {
            if (retailer[facetType]?.[facetName]) {
              counter += 1;
            }
          });

          if (counter > 0) {
            const element = {
              facetType,
              facetName,
              name: retailConnectTranslation(facetName, this.$dict),
              count: counter,
              selected: false,
            };

            facet.elements.push(element);
          }
        });

        facets.push(facet);
      });

      this.retailerFacets = facets;
    },
  },
};
</script>
